
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-1 -1 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16","cy":"16","r":"16","fill":"#D2D5D9"}}),_c('path',{staticClass:"black-fill",attrs:{"d":"M25 10.69l-4.605 4.643a6.203 6.203 0 01-4.393 1.835 6.203 6.203 0 01-4.397-1.824L7 10.701 9.662 8l6.332 6.358L22.326 8 25 10.69zM15.226 17.895h1.56c.294.001.575.12.783.33.207.21.324.494.325.79V24h-3.782v-4.985a1.128 1.128 0 01.326-.793 1.113 1.113 0 01.788-.327z","fill":"#fff"}})])
          )
        }
      }
    